import apiClient from "./api-client";

interface EngagementEvent {
  event_type: string;
  event_data: Record<string, unknown>;
}

const buffer: EngagementEvent[] = [];
let flushTimer: ReturnType<typeof setTimeout> | null = null;
const sessionId = crypto.randomUUID();

/** Per-tab session id, shared with feedback events so signals correlate. */
export function getSessionId(): string {
  return sessionId;
}

export function trackEvent(type: string, data?: Record<string, unknown>) {
  buffer.push({ event_type: type, event_data: data ?? {} });
  if (buffer.length >= 10) {
    flush();
  } else if (!flushTimer) {
    flushTimer = setTimeout(flush, 5000);
  }
}

async function flush() {
  if (!buffer.length) return;
  const batch = buffer.splice(0);
  if (flushTimer) {
    clearTimeout(flushTimer);
    flushTimer = null;
  }
  try {
    await apiClient.post("api/events", {
      json: { events: batch, session_id: sessionId },
    });
  } catch {
    // Silent — never let tracking block UX
  }
}

if (typeof window !== "undefined") {
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
}
